<template>
  <div class="ibox">
    <div class="ibox-title">
      XML AUTHENTICATOR
    </div>
    <div class="ibox-content">
      <XmlAuthenticator/>
    </div>
  </div>

</template>

<script>
  import XmlAuthenticator from '@/components/definitions/integrations/XmlAuthenticator'

  export default {
    components: { XmlAuthenticator },
    name: 'Integration'
  }
</script>

<style scoped>

</style>